<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">我的贷款</div>
      <div :class="[status==3? 'checkingBg' : 'checkSuccessBg', 'status-wrap']">
        <div class="img">
          <img :src="img" />
        </div>
        <div class="status">
          申请状态
          <br />
          <p>{{status==4?'已通过':`审核中，${approval}`}}</p>
        </div>
      </div>
      <!-- 未通过补充资料 -->
      <div class="supply">
        <div class="title">{{status==3?'贷款人补充资料':'贷款信息'}}</div>
        <div class="file" v-if="status==3">
          <span>贷款人资料</span>
          <!-- <ListUpload
            style="display:inline-block; margin-left:310px;"
            :fileFuther.sync="file"
            :downFlag="true"
          />-->
          <Upload v-model="imgUrl" @fileNameEvt="fileNameEvt" :size="true"></Upload>
        </div>
        <div class="file-list">
          <div v-for="(item, index) in fileList" :key="index">
            <el-link
              type="primary"
              :underline="false"
              target="_blank"
              :href="item.fileAddr"
            >{{item.fileName}}</el-link>
            <i class="close el-icon-close" @click="del(index)"></i>
          </div>
        </div>
        <div class="info" v-if="status==4">
          <div>
            <span>审批额度</span>
            <span>{{info.approvalAmount}}万</span>
          </div>
          <div>
            <span>贷款期限</span>
            <span>{{info.deadline}}年</span>
          </div>
          <div>
            <span>贷款利率</span>
            <span>{{info.interestRate}}%</span>
          </div>
          <div>
            <span>还款方式</span>
            <span>{{info.repayment | repayment}}</span>
          </div>
          <div>
            <span>发放方式</span>
            <span>{{info.issuingMethod == 1 ? '银行直接发放' : '现场办理'}}</span>
          </div>
        </div>
      </div>
      <div class="btn">
        <el-button @click="$router.go(-1)" v-if="status==4">返回</el-button>
        <div v-else>
          <el-button @click="$router.go(-1)">取消</el-button>
          <el-button class="sumbit" @click="sumbit()">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderImg from "@/components/HeaderImg";
import LoadingImg from "@/assets/img/check_ing.png";
import SuccessImg from "@/assets/img/check_success.png";
import ListUpload from "@/components/DataUpload/OneUpload";
import Upload from "@/components/Upload/UpLoad.vue";
import { sessionStore } from '@/utils/data-management';
export default {
  components: {
    HeaderImg,
    ListUpload,
    Upload
  },
  data() {
    return {
      headerList: [
        { name: "产权流转交易中心", path: "/Home" },
        { name: "我的贷款", path: "/myLoan" },
        { name: "审核中，补资料" }
      ],
      img: LoadingImg,
      status: this.$route.query.status,
      fileList: [],
      info: {},
      imgUrl: "",
      approval: sessionStore.get('loanApproval')
    };
  },
  filters: {
    repayment(val) {
      let res = "等额本金";
      if (val == 2) {
        res = "等额本息";
      } else if (val == 3) {
        res = "按月还息到期还本";
      } else if (val == 4) {
        res = "到期一次还本付息";
      }
      return res;
    }
  },
  methods: {
    init() {
      if (this.$route.query.status == 4) {
        this.img = SuccessImg;
        this.headerList[2] = { name: "已通过" };
        this.$api.apply
          .loanDetail({ loanId: this.$route.query.id })
          .then(res => {
            if (res.code == 1000) {
              this.info = res.data;
            }
          });
      }
    },
    fileNameEvt(val) {
      this.fileList.push({
        fileName: val,
        fileAddr: this.imgUrl
      });
    },
    del(index) {
      // if(this.fileList.length == 1) {
      //   this.fileList = []
      // }
      this.fileList.splice(index, 1);
    },
    sumbit() {
      if (this.fileList.length > 0) {
        let data = {
          loanId: this.$route.query.id,
          loanAddFileEntities: this.fileList
        };
        this.$api.apply.loanAddFile(data).then(res => {
          if(res.code == 1000) {
            this.$message.success('提交成功，等待审核')
            setTimeout(() => {
              this.$router.go(-1)
            }, 500);
          }
        });
      } else {
        this.$message.error("请先上传贷款人资料");
      }
    }
  },
  created () {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.main-block {
  padding: 35px;
  .top-title {
    margin-bottom: 43px;
  }
  .status-wrap {
    // width: 954px;
    width: 900px;
    height: 110px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    .img {
      width: 110px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 38px;
    }
    .status {
      p {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        margin: 8px 0;
      }
    }
    &.checkSuccessBg {
      background: #f0f9f0;
      .img {
        background: #91a442;
        border-radius: 4px;
      }
      p {
        color: #91a442;
      }
    }
    &.checkingBg {
      background: #fef9f0;
      .img {
        background: #ffaa36;
        border-radius: 4px;
      }
      p {
        color: #f78c00;
      }
    }
  }
  .supply {
    width: 900px;
    margin: 0 auto;
    .title {
      width: 846px;
      // width: 900px;
      line-height: 54px;
      padding-left: 54px;
      margin: 20px 0;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #394259;
      background: #f8f9fb;
    }
    .file {
      color: #007bff;
      align-items: center;
      margin-left: 54px;
      display: flex;
      /deep/ .el-upload {
        margin-left: 260px;
        .el-button {
          color: #007bff;
          border-color: #007bff;
          .el-icon-plus {
            display: none;
          }
        }
      }
    }
    .file-list {
      margin: 20px 0 20px 54px;
      cursor: pointer;
      /deep/ .el-link {
        color: #007bff;
        margin-bottom: 5px;
      }
    .el-icon-close {
      font-size: 18px;
      position: relative;
      top: 2px;
      left: 20px;
      color: #007bff;
    }
    }
    .info {
      margin-left: 54px;
      div {
        line-height: 40px;
        font-family: PingFangSC-Regular;
        color: #394259;
        span:first-child {
          // color: #007bff;
          margin-right: 87px;
          color: #60697e;
        }
      }
    }
  }
  .btn {
    margin-right:116px;
    margin-top: 210px;
    .el-button {
      border-radius: 2px;
    }
    .el-button + .el-button {
      margin-left: 20px;
    }
  }
}
</style>